export const numberAddCommas = (value: number | string): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * Formats a number with comma separators for thousands (e.g. 10000 → "10,000").
 * Use this for all count/figure displays across the UI for consistency.
 */
export const formatCount = (value: number): string => {
  return new Intl.NumberFormat('en-US').format(value);
};
